import React, { useState } from 'react'
import Navigator from '../../components/common/Navigator'
import { useLocation, useNavigate } from 'react-router-dom'
// import parse from 'html-react-parser'
import { Button } from '../../components/common'
import DOMPurify from 'dompurify'
import { useAuthStore } from '../../store/authStore'
import { useCreateEventBooking } from '../Departments/learning/Form/api'

const roleMap: Record<number, string> = {
  2: 'Aspiring Entrepreneur',
  3: 'School',
  4: 'Existing Entrepreneur',
  5: 'Research Scholar',
  6: 'Industry Association',
  7: 'Mentor',
  8: 'Entrepreneurship Club',
  9: 'Student',
  10: 'Guest',
}
const EventDetails: React.FC = () => {
  const location = useLocation()
  const { event } = location.state || {}
  const { userData } = useAuthStore()
  const navigate = useNavigate()
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showFeeModal, setShowFeeModal] = useState(false)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const { mutate: bookEvent } = useCreateEventBooking(() => {
    // Handle success - show custom success modal
    console.log('Event booking successful!')
    setShowSuccessModal(true)
  })

  const handleBookNow = () => {
    if (isSubmitting) return
    if (!userData?.id) {
      alert('Please login to book this event')
      return
    }

    // Check if event has fees
    if (event.fees && event.fees > 0) {
      // Show fee selection modal
      setShowFeeModal(true)
    } else {
      // No fees, book directly
      handleDirectBooking()
    }
  }

  const handleDirectBooking = () => {
    if (isSubmitting) return
    // Create booking data - always include fees key
    const bookingData: any = {
      user_id: userData.id,
      event_id: event.id,
      fees: event.fees || 0,
    }

    console.log('Submitting event booking:', bookingData)
    setIsSubmitting(true)
    bookEvent(bookingData, {
      onSettled: () => {
        setIsSubmitting(false)
      },
    })
  }

  const handleFeeSelection = () => {
    setShowFeeModal(false)
    handleDirectBooking()
  }

  if (!event) {
    return (
      <p className="text-center text-red-500 mt-6">No event data available</p>
    )
  }
  let parsedRoles: number[] = []
  try {
    parsedRoles = event.roles ? JSON.parse(event.roles) : []
  } catch (err) {
    console.error('Invalid roles format:', event.roles)
  }
  const capitalizeHTMLText = (html: string) => {
    if (!html) return ''
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')

    const capitalizeNode = (node: ChildNode) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const text = node.textContent || ''
        node.textContent = text.replace(/^\s*\w/, (c) => c.toUpperCase())
      } else if (node.childNodes.length > 0) {
        node.childNodes.forEach(capitalizeNode)
      }
    }

    doc.body.childNodes.forEach(capitalizeNode)
    return doc.body.innerHTML
  }

  return (
    <div className="lg:w-11/12 mx-auto py-6 font-sans">
      <div>
        <Navigator title="Events Detail" slug="UPCOMMINGEVENTS_DETAIL" />
      </div>

      <div className="mt-4">
        <span className="bg-blue-600 text-white text-[16px] px-4 py-[6px] rounded-full mb-5 align-middle">
          {event.status}
        </span>
      </div>

      {/* <h1 className="text-3xl font-semibold text-gray-900 mt-3">
        {event.name}
      </h1> */}
      <h1 className="text-3xl font-semibold text-gray-900 mt-3">
        {event.name
          ? event.name.charAt(0).toUpperCase() + event.name.slice(1)
          : ''}
      </h1>

      <p className="text-gray-500 mt-1 mb-6">
        Gaining Insights: From Branding to E-commerce
      </p>
      <hr className="border-t-2 border-primaryBlue " />

      <div className="space-y-4 text-gray-900 mt-3">
        <div className="flex mb-4">
          <span className="font-[800]  text-[18px] w-48">Date</span>
          <span className="font-semibold w-10"> :</span>
          <span className="text-blue-700 font-[800] text-[18px] pt-[1px]">
            {new Date(event.event_start_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            })}
          </span>
        </div>
        {event?.location && (
          <div className="flex">
            <span className="font-semibold w-48">Location</span>
            <span className="font-semibold w-10"> :</span>
            <span className="text-blue-600 font-[800]">{event.location}</span>
          </div>
        )}
        {event?.department && (
          <div className="flex">
            <span className="font-semibold w-48">Departments</span>
            <span className="font-semibold w-10"> :</span>
            <span className="text-blue-600 font-[800]">
              {event.department.name || 'N/A'}
            </span>
          </div>
        )}
        <div className="flex">
          <span className="font-semibold text-[16px] w-48">
            Booking End Date
          </span>
          <span className="font-semibold w-10"> :</span>
          <span className="text-blue-600 font-[800]">
            {new Date(event.booking_end_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'long',
              year: 'numeric',
            })}
          </span>
        </div>
        <div className="flex">
          <span className="font-semibold w-48">Number Of Seats Available</span>
          <span className="font-semibold w-10"> :</span>
          <span className="text-blue-600 font-[800]">
            {event.seats || 'N/A'}
          </span>
        </div>
        <div className="flex">
          <span className="font-semibold w-48">Fees</span>
          <span className="font-semibold w-10"> :</span>
          <span className="text-blue-600 font-[800]">
            {event.fees || 'N/A'}
          </span>
        </div>
      </div>

      {/* Description + Image */}
      <div className="mt-8 flex flex-col md:flex-row gap-8 justify-between text-justify">
        <div
          className="mt-6 text-gray-900 leading-7"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              capitalizeHTMLText(event.description || ''),
              {
                FORBID_ATTR: ['style'], // removes inline styles for security
              }
            ),
          }}
        />
        <div className="mt-8">
          <img
            src={event.thumb || 'https://via.placeholder.com/600x300'}
            alt={event.name}
            className="rounded-lg shadow-md"
          />
        </div>
      </div>
      <div className="py-4 mt-auto">
        <Button
          label={isSubmitting ? 'Processing...' : 'Book Now'}
          outlined
          disabled={isSubmitting}
          className={`border-1 border-PrimaryOrange text-PrimaryOrange rounded-sm px-10 py-3 hover:bg-PrimaryOrange hover:text-white ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
          onClick={handleBookNow}
        ></Button>
      </div>
      {parsedRoles.length > 0 && (
        <div className="mt-12">
          <h2 className="text-2xl font-bold mb-6">For Whom?</h2>
          <ul className="space-y-3 text-gray-900 ">
            {parsedRoles.map((roleId: number, index: number) => (
              <li
                key={index}
                className="flex items-start gap-2 font-bold text-[16px]"
              >
                <span className="text-primaryBlue text-lg">▶</span>
                <span>{roleMap[roleId] || `Unknown Role (${roleId})`}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Success Modal */}
      {showSuccessModal && (
        <div className="fixed inset-0 backdrop-blur-md bg-white/20 flex items-center justify-center z-50 animate-fade-in">
          <div className="bg-white rounded-2xl p-8 max-w-md w-full mx-4 transform transition-all duration-300 ease-out scale-100 shadow-2xl border border-gray-100">
            <div className="text-center">
              {/* Animated Success Icon */}
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gradient-to-r from-green-400 to-green-600 mb-6 animate-bounce-in">
                <svg
                  className="h-8 w-8 text-white animate-checkmark"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="3"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
              </div>

              {/* Success Title */}
              <h3 className="text-2xl font-bold text-gray-900 mb-3 animate-slide-up">
                Successfully Registered!
              </h3>

              {/* Success Message */}
              <p className="text-gray-600 mb-8 animate-slide-up-delay">
                Admin will contact you soon.
              </p>

              {/* OK Button */}
              <div className="flex justify-center animate-slide-up-delay-2">
                <Button
                  label="OK"
                  className="w-[200px] bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 text-[20px]"
                  onClick={() => {
                    setShowSuccessModal(false)
                    navigate('/') // Navigate to home page
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Fee Selection Modal */}
      {showFeeModal && (
        <div className="fixed inset-0 backdrop-blur-xl bg-gradient-to-br from-white/90 to-white/70 flex items-center justify-center z-50 animate-fade-in">
          <div className="bg-white/95 backdrop-blur-sm rounded-3xl p-8 max-w-md w-full mx-4 transform transition-all duration-500 ease-out scale-100 shadow-2xl border border-white/20 shadow-black/10">
            <div className="text-center">
              {/* Modal Header with Icon */}
              <div className="mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                  <svg
                    className="w-8 h-8 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent mb-2">
                  Event Registration
                </h3>
                <p className="text-gray-600 text-sm">
                  Complete your registration for this event
                </p>
              </div>

              {/* Fee Display */}
              <div className="bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 border border-blue-200/50 rounded-2xl p-4 mb-8 max-w-[220px] mx-auto shadow-lg shadow-blue-200/50">
                <div className="text-center">
                  <h4 className="text-sm font-bold text-blue-900 mb-1">
                    Event Fee
                  </h4>
                  <p className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-1">
                    ₹{event.fees}
                  </p>
                  <p className="text-xs text-blue-700">
                    This is the fee for this event
                  </p>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="flex justify-center space-x-4">
                <Button
                  label="Cancel"
                  outlined
                  className="px-8 py-2 border-gray-300 text-gray-700 hover:bg-gray-50 hover:shadow-md transition-all duration-200"
                  onClick={() => setShowFeeModal(false)}
                />
                <Button
                  label={isSubmitting ? 'Submitting...' : 'Submit'}
                  disabled={isSubmitting}
                  className={`px-8 py-2 bg-gradient-to-r from-blue-500 to-purple-600 hover:from-blue-600 hover:to-purple-700 text-white font-bold rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
                  onClick={() => handleFeeSelection()}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default EventDetails
